import { FC, useEffect, useState } from "react";
import { Box, SxProps, Theme, Typography } from "@mui/material";
import { useAppDataContext } from "@context/AppContext";
import { gameState, useTeamSides } from "@/services/gameState";

interface TeamCoachNameProps {
  side: "left" | "right";
  fontSize: string;
  sx?: SxProps<Theme>;
}

const TeamCoachName: FC<TeamCoachNameProps> = ({ side, sx, fontSize }) => {
  const teamSquads = gameState("teamSquads");
  const { leftTeam, rightTeam } = useTeamSides(useAppDataContext());

  const [teamReference, setTeamReference] = useState(
    side === "left" ? leftTeam : rightTeam,
  );

  useEffect(() => {
    setTeamReference(side === "left" ? leftTeam : rightTeam);
  }, [leftTeam, rightTeam, side]);

  const { showPlayerNames } = useAppDataContext();

  const coach = teamSquads[teamReference].officials.find(
    (official) => official.function === "TRAINER",
  );

  const coachName = coach ? `${coach.firstName} ${coach.lastName}` : "";

  return (
    <Box
      display={"flex"}
      flexDirection={side === "right" ? "row" : "row-reverse"}
      justifyContent={"flex-end"}
      sx={sx}
    >
      <Typography fontSize={fontSize}>
        {showPlayerNames ? coachName : ""}
      </Typography>
    </Box>
  );
};

export default TeamCoachName;
